"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import { IndustryCardsCarouselProps } from "./types";
import Link from "next/link";
import Icon from "@/components/ui/Icon";
import IndustryCard from "../IndustryCard";

const IndustryCardsCarousel = ({
  className,
  cards,
}: IndustryCardsCarouselProps) => {
  const cardStatic = cards?.find((card) => card?.isStatic);

  return (
    <Carousel.Mobile
      options={{
        slides: {
          spacing: 24,
          perView: "auto",
        },
      }}
      showNavigation
      className={cn(
        "md:!grid md:!grid-cols-2 md:!gap-4 !overflow-visible [&>[data-carousel-slide]:not(.carousel-slide-active)]:opacity-50",
        className
      )}
      navigationSlot={
        !!cardStatic?.link && (
          <Link
            href={cardStatic?.link}
            className="flex-auto py-3 px-8 flex items-center gap-4 min-w-0 border border-blue-500 text-[#2F80ED] text-base leading-[150%] font-semibold md:hidden rounded-3xl"
          >
            <span className="truncate flex-auto min-w-0">
              Explore industries
            </span>
            <Icon
              id="icon-arrow-right-lg_24"
              width={24}
              height={24}
              className="shrink-0 w-6 h-6"
            />
          </Link>
        )
      }
    >
      {cards.map(({ isStatic, title, description, imageUrl, link }, index) => {
        return (
          <CarouselSlide
            key={index}
            className="!min-w-[82%] !w-[82%] !md:min-w-auto !w-auto transition-opacity duration-300 will-change-[opacity] md:transition-none md:!opacity-100 md:duration-initial"
          >
            <IndustryCard
              isStatic={isStatic}
              title={title}
              imageUrl={imageUrl}
              description={!isStatic ? description : ""}
              link={link}
              linkLabel={isStatic ? "See all" : "Learn more"}
            />
          </CarouselSlide>
        );
      })}
    </Carousel.Mobile>
  );
};

export default memo(IndustryCardsCarousel);
